import type { Editor } from "@tiptap/core";

/**
 * The editor if it can still be driven, otherwise null.
 *
 * tiptap v3's `Editor.destroy()` nulls the command manager, and unlike
 * `chain()` and `can()`, the `commands` getter has no fallback: calling
 * `editor.commands.anything` on a destroyed editor throws. Under v2 the same
 * call was a silent no-op, which let code keep an editor past its owner
 * component's life without consequence. Every holder of an editor it does
 * not own (page state fed by `onEditorReady`, `window.fp.editor` read from a
 * websocket handler) goes through this before calling in (#11904).
 *
 * `isDestroyed` is also true for an editor whose view has been unmounted
 * but not destroyed. That is deliberate here: none of the holders above
 * has any business driving an editor with no view either.
 */
export function liveEditor(editor: Editor | null | undefined): Editor | null {
  if (!editor || editor.isDestroyed) {
    return null;
  }
  return editor;
}
